/* unplugin-vue-components disabled */import script from "./list.vue?vue&type=script&setup=true&name=CacheList&lang=js"
export * from "./list.vue?vue&type=script&setup=true&name=CacheList&lang=js"

const __exports__ = script;

export default __exports__